import React, { FunctionComponent } from "react";
import Link from "next/link";

import {
  ICallToAction,
  ICallToActionFields,
  ILinkFields,
} from "@/types/generated/contentful";
import { generateCTAUrl } from "@/helpers/url";
import { Button } from "@/components/button";

type Props = {
  content: ICallToAction;
  nav?: Boolean;
  appendClass?: string;
};

const CallToAction: FunctionComponent<Props> = ({
  content,
  nav = false,
  appendClass = "",
}) => {
  const cta = content.fields as ICallToActionFields;
  const url = generateCTAUrl(cta.action);
  const customized = cta.foreground || cta.background || cta.hoverBackground;

  if (
    cta.action.sys.contentType.sys.id === "link" &&
    !nav &&
    !(cta.action.fields as ILinkFields).url.startsWith("/") &&
    !(cta.action.fields as ILinkFields).url.startsWith(
      "https://app.sponsorpulse.com",
    )
  ) {
    const actionFields = cta.action.fields as ILinkFields;
    let rel = [];
    if (!!actionFields.noopener) rel.push("noopener");
    if (!!actionFields.nofollow) rel.push("nofollow");
    if (!!actionFields.noreferral) rel.push("noreferrer");
    return (
      <a href={url} rel={rel.join(" ")} target="_blank">
        <Button
          size={cta.size || "base"}
          style={cta.style}
          label={nav ? cta.title : cta.text}
          {...(customized ? { className: "" } : {})}
        />
      </a>
    );
  }

  return (
    <Link className="w-full" href={url} tabIndex={-1}>
      <Button
        size={cta.size || "base"}
        style={cta.style}
        appendClass={nav ? `hover:no-underline ${appendClass}` : appendClass}
        customizedStyle={{
          color: cta.foreground,
          background: cta.background,
          hover: {
            background: cta.hoverBackground,
          },
        }}
        label={nav ? cta.title : cta.text}
      />
    </Link>
  );
};

export default CallToAction;
